import { render, staticRenderFns } from "./ConfirmDesignDeviation.vue?vue&type=template&id=626bd610&scoped=true"
import script from "./ConfirmDesignDeviation.vue?vue&type=script&lang=ts"
export * from "./ConfirmDesignDeviation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626bd610",
  null
  
)

export default component.exports